import {
  Button,
  Content,
  InputBox,
  Img,
  FileUploadButton,
  TextAreaBox,
  ContentLayout,
} from "@adminComponents";
import React, {useEffect, useState} from "react";
import styles from "./style.module.scss";
import {useAdminNav} from "@hook";
import {adminApi, utils} from "@utils";
import * as Datas from "@adminData";
import {AdminScreenId} from "@assets";
import moment from "moment";

export default function Page() {
  const {navigate, getParams} = useAdminNav();
  const {no} = getParams<{no?: number}>();
  const [detail, setDetail] = useState<Datas.INoticeResponse>({});

  const isEdit = !!detail.no;

  async function getDetail() {
    try {
      if (!no) {
        return;
      }

      const {data, success, message} = await adminApi.notice.getDetail({no});
      if (success) {
        setDetail(data);
      } else {
        alert(message || "오류가 발생했습니다");
      }
    } catch (error) {
      console.error("getDetail error", error);
    }
  }

  async function write() {
    try {
      if (!detail.title || !detail.content) {
        alert("모든 데이터를 입력해주세요.");
        throw Error("필수값 누락");
      }
      const {success, data, message} = await adminApi.notice.write({
        ...detail,
        title: detail.title,
        content: detail.content,
      });
      if (success) {
        navigate({
          url: AdminScreenId.NOTICE_DETAIL,
          params: {no: data?.no},
        });
      } else {
        alert(message);
      }
    } catch (error) {
      console.error("write error", error);
    }
  }

  async function edit() {
    try {
      if (!detail.no || !detail.title || !detail.content) {
        alert("모든 데이터를 입력해주세요.");
        throw Error("필수값 누락");
      }
      const {success, message} = await adminApi.notice.edit({
        ...detail,
        no: detail.no,
        title: detail.title,
        content: detail.content,
      });
      if (success) {
        getDetail();
      } else {
        alert(message);
      }
    } catch (error) {
      console.error("edit error", error);
    }
  }

  async function deleteData() {
    try {
      if (!detail.no) {
        return;
      }
      if (!confirm("삭제하시겠습니까?")) {
        return;
      }
      const {success, message} = await adminApi.notice.delete({
        no: detail.no,
      });
      alert(message);
      if (success) {
        navigate({url: AdminScreenId.NOTICE});
      }
    } catch (error) {
      console.error("edit error", error);
    }
  }

  useEffect(() => {
    getDetail();
  }, [no]);

  return (
    <>
      <ContentLayout
        title="공지사항 상세"
        rightElement={
          <div className={styles.bottomSection}>
            {isEdit ? (
              <>
                <div>
                  <Button
                    backgroundColor="#d9d9d9"
                    fontSize={18}
                    paddingHorizontal={39}
                    paddingVertical={12}
                    text={"삭제"}
                    onClick={deleteData}
                  />
                </div>
                <div>
                  <Button
                    backgroundColor="#d9d9d9"
                    fontSize={18}
                    paddingHorizontal={39}
                    paddingVertical={12}
                    text={"수정"}
                    onClick={edit}
                  />
                </div>
              </>
            ) : (
              <>
                <div>
                  <Button
                    backgroundColor="#d9d9d9"
                    fontSize={18}
                    paddingHorizontal={39}
                    paddingVertical={12}
                    text={"등록"}
                    onClick={write}
                  />
                </div>
              </>
            )}
          </div>
        }>
        <Content>
          <div className={styles.content}>
            <div className="row">
              <div className="col title">제목</div>
              <div className="col">
                <InputBox
                  value={detail?.title}
                  onValue={value => {
                    setDetail({...detail, title: value});
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
            <div className="row">
              <div className="col title">내용</div>
              <div className="col">
                <TextAreaBox
                  value={detail?.content}
                  onValue={value => {
                    setDetail({...detail, content: value});
                  }}
                  boxStyle={{flex: 1, minHeight: 300}}
                />
              </div>
            </div>
            <div className="row">
              <div className="col title">이미지</div>
              <div className="col">
                <div>
                  <FileUploadButton
                    text={"업로드"}
                    height={32}
                    width={32}
                    multiple
                    uploadUrl={"/api/v1/upload/notice"}
                    fileUpload={data => {
                      const newFiles: Datas.IFiles[] = [
                        ...(detail.files || []),
                        ...(data.files || []).map((item, index) => ({
                          url: item,
                          thumb_img_url: (data.thumbList || [])[index],
                        })),
                      ];
                      setDetail?.({
                        ...detail,
                        files: newFiles,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={styles.imageContainer}>
              {(detail.files || []).map(({url, thumb_img_url}, index) => {
                const imgUrl = thumb_img_url || url;
                return (
                  <div key={index} className={styles.imageContainer}>
                    <Img src={imgUrl} className={styles.img} />
                    <div className={styles.btnContainer}>
                      {index > 0 && (
                        <div
                          className={styles.item}
                          onClick={() => {
                            const newFiles = utils.moveArrayValue({
                              array: detail.files || [],
                              fromIndex: index,
                              toIndex: index - 1,
                            });
                            setDetail?.({
                              ...detail,
                              files: newFiles,
                            });
                          }}>
                          🔼
                        </div>
                      )}
                      <div
                        className={styles.item}
                        onClick={() => {
                          if (!confirm("이미지를 삭제하시겠습니까?")) {
                            return;
                          }
                          setDetail({
                            ...detail,
                            files: (detail.files || []).filter(
                              (temp, i) => i !== index,
                            ),
                          });
                        }}>
                        ❎
                      </div>
                      {index < (detail.files || []).length - 1 && (
                        <div
                          className={styles.item}
                          onClick={() => {
                            const newImages = utils.moveArrayValue({
                              array: detail.files || [],
                              fromIndex: index,
                              toIndex: index + 1,
                            });
                            setDetail({
                              ...detail,
                              files: newImages,
                            });
                          }}>
                          🔽
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Content>
      </ContentLayout>
    </>
  );
}
